var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',{attrs:{"title":_vm.$t('dashboard.title'),"icon":"fa fa-home text-turquoise"}},[_c('div',{staticClass:"mt-2 flex flex-col space-y-6"},[_c('TotalsPartial'),_c('ChartsPartial')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }